import { render, staticRenderFns } from "./NotesItem.vue?vue&type=template&id=162719e4"
import script from "./NotesItem.vue?vue&type=script&lang=js"
export * from "./NotesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports